import { useEffect } from "react";
import { Footer } from "./components/Footer";
import { Grain } from "./components/Grain";
import { Nav } from "./components/Nav";
import { WaitlistProvider } from "./components/WaitlistProvider";
import { useUtmCapture } from "./hooks/useUtmCapture";
import { initClarity, initGa4 } from "./lib/analytics";
import { FooterCta } from "./sections/FooterCta";
import { Hero } from "./sections/Hero";
import { PortalSection } from "./sections/PortalSection";
import { ProblemSection } from "./sections/ProblemSection";
import { ProductSection } from "./sections/ProductSection";
import { UseCasesSection } from "./sections/UseCasesSection";
import { VisionSection } from "./sections/VisionSection";

export function App() {
  useUtmCapture();

  useEffect(() => {
    initGa4();
    initClarity();
  }, []);

  return (
    <WaitlistProvider>
      <Grain />
      <Nav />
      <main>
        <Hero />
        <ProblemSection />
        <VisionSection />
        <PortalSection />
        <ProductSection />
        <UseCasesSection />
        <FooterCta />
      </main>
      <Footer />
    </WaitlistProvider>
  );
}
